import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Boton from "../boton/Boton";
import Error from "../generales/Error";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Colors from "components/etiquetas/Colors";

const FormularioIngresos = ({ ingreso, cargando }) => {
  const [error, setError] = useState(false);

  const navigate = useNavigate();

  const nuevoIngresoSchema = Yup.object().shape({
    concepto: Yup.string(),
    fecha: Yup.date().required("Este campo es obligatorio"),
    importe: Yup.number()
      .positive("Importe no válido")
      .typeError("Sólo valores númericos")
      .required("Este campo es obligatorio"),
    descripcion: Yup.string(),
    tipo_cuenta: Yup.string(),
    imagen: Yup.mixed(),
  });

  const handleSubmit = async (valorIngreso) => {
    try {
      const url = "http://localhost:4000/gastos";

      const { status, data } = await axios.post(url, valorIngreso);
      console.log(status, data);
      if (status === 200) {
        console.log("Ingreso registrado");
      }
      navigate("/gastos");
    } catch (error) {
      console.log(error);
      setError(true);
      return;
    }
    setError(false);
  };

  return (
    <Formik
      initialValues={{
        concepto: ingreso?.concepto ?? "",
        fecha: ingreso?.fecha
          ? new Date(ingreso?.fecha_corte).toISOString().slice(0, 10)
          : "",
        importe: ingreso?.importe ?? "",
        descripcion: ingreso?.descripcion ?? "",
        tipo_cuenta: ingreso?.tipo_cuenta ?? "",
      }}
      onSubmit={async (values, { resetForm }) => {
        await handleSubmit(values);

        resetForm();
      }}
      validationSchema={nuevoIngresoSchema}
    >
      {({ errors, touched }) => {
        return (
          <Form>
            <div className="formulario-input">
              <label htmlFor="concepto">Concepto</label>
              <Field component="select" id="tipo_cuenta" name="tipo_cuenta">
                <option value="">--Elige el concepto--</option>
              </Field>
              {errors.concepto && touched.concepto ? (
                <Error>{errors.concepto}</Error>
              ) : null}
            </div>

            <div className="formulario-input">
              <label htmlFor="fecha">Fecha del ingreso</label>
              <Field
                id="fecha"
                type="date"
                placeholder="Fecha del ingreso"
                name="fecha"
              />
              {errors.fecha && touched.fecha ? (
                <Error>{errors.fecha}</Error>
              ) : null}
            </div>
            <div className="formulario-input">
              <label htmlFor="importe">Importe</label>
              <Field
                id="importe"
                type="number"
                placeholder="$"
                name="importe"
              />
              {errors.importe && touched.importe ? (
                <Error>{errors.importe}</Error>
              ) : null}
            </div>

            <div className="formulario-input">
              <label htmlFor="descripcion">Descripción</label>
              <Field
                id="descripcion"
                type="textarea"
                placeholder="Descripción del ingreso"
                name="descripcion"
              />
              {errors.descripcion && touched.descripcion ? (
                <Error>{errors.descripcion}</Error>
              ) : null}
            </div>

            <div className="formulario-input">
              <label htmlFor="cuenta">Cuenta</label>
              <Field component="select" id="tipo_cuenta" name="tipo_cuenta">
                <option value="">Elige el tipo de cuenta</option>
                <option value="Cuenta">Cuenta</option>
                <option value="Ahorro">Ahorro</option>
                <option value="Nomina">Nómina</option>
                <option value="Efectivo">Efectivo</option>
                <option value="Inversion">Inversión</option>
                <option value="Crédito">Crédito</option>
                <option value="Wallet">Wallet</option>
                <option value="Departamental">Departamental</option>
                <option value="Vales">Vales</option>
              </Field>
              {errors.tipo_cuenta && touched.tipo_cuenta ? (
                <Error>{errors.tipo_cuenta}</Error>
              ) : null}
            </div>
            <div className="formulario-input">
              <label htmlFor="color">Etiqueta</label>
              <Field id="color" component={Colors} name="color">
                <Colors />
                {errors.color && touched.color ? (
                  <Error>{errors.color}</Error>
                ) : null}
              </Field>
            </div>

            <Boton>Guardar</Boton>
          </Form>
        );
      }}
    </Formik>
  );
};

export default FormularioIngresos;
